import { Deserializable } from '../deserializable';

export class WorldpayDataDto implements Deserializable {
  public PaymentGuid: string;
  public Url: string;
  public InstId: string;
  public TestMode: string;
  public Currency: string;
  public CartId: string;
  public MerchantId: string;
  public ShopperAdditionalAccountNumber: string;
  public ShopperAdditionalLastName: string;
  public ShopperAdditionalBirthDate: string;
  public ShopperAdditionalPostalCode: string;
  public Signature: string;
  public Amount?: number;
  public Email: string;
  public ValuationFee?: number;
  public ValuationFeDprId: string;
  public BookingFee?: number;
  public BookingFeeDprId: string;
  public Name: string;
  public PostCode: string;
  public Tel: string;
  public OperationId: string;
  public Description: string;
  public Country: string;
  public HideCurrency: boolean;

  deserialize(input: any): this {
    Object.assign(this, input);

    return this;
  }
}
